import { Chip } from '@mui/material';
import { CommonTagChip, GeneralTagChip } from './styled';

export const ACCEPTED_MIME_TYPES = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const ACCEPTED_EXTENSIONS = '.pdf,.docx';

export type SourceMode = 'text' | 'document';

export const formatFileSize = (bytes: number) => {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const hasContextSizeTag = (tags: string[]): boolean =>
  tags.some((t) => {
    const lower = t.toLowerCase();
    return lower.startsWith('general:context') || lower.startsWith('areacontext:');
  });

export const getTagChipComponent = (option: string) => {
  if (option.toLowerCase().includes('common:')) {
    return CommonTagChip;
  }
  if (option.toLowerCase().includes('general:')) {
    return GeneralTagChip;
  }
  return Chip;
};
